(() => {
  function init(root = document) {
    root.querySelectorAll('[data-dtf-article]').forEach((article, articleIndex) => {
      if (article.dataset.navigationReady) return;
      article.dataset.navigationReady = 'true';
      const content = article.querySelector('[data-dtf-article-content]');
      const toc = article.querySelector('[data-dtf-toc]');
      const headings = content ? Array.from(content.querySelectorAll('h2')) : [];
      if (!toc || headings.length < 3) return;
      const list = toc.querySelector('ol');
      headings.forEach((heading, i) => {
        let target = heading.id;
        if (!target) {
          target = `dtf-toc-${articleIndex}-${i}`;
          while (document.getElementById(target)) target += '-section';
          const anchor = document.createElement('span');
          anchor.id = target;
          anchor.className = 'dtf-toc-target';
          anchor.setAttribute('aria-hidden', 'true');
          heading.before(anchor);
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + target;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      toc.hidden = false;
    });
    root.querySelectorAll('[data-dtf-archive]').forEach(archive => {
      if (archive.dataset.filterReady) return;
      archive.dataset.filterReady = 'true';
      const search = archive.querySelector('[data-archive-search]');
      const category = archive.querySelector('[data-archive-category]');
      const count = archive.querySelector('[data-archive-count]');
      const empty = archive.querySelector('[data-archive-empty]');
      const items = Array.from(archive.querySelectorAll('[data-archive-item]'));
      function filter() {
        const term = search.value.trim().toLocaleLowerCase();
        let visible = 0;
        items.forEach(item => {
          const match = (!category.value || item.dataset.category === category.value) && (!term || item.textContent.toLocaleLowerCase().includes(term));
          item.hidden = !match;
          if (match) visible++;
        });
        count.textContent = `${visible} ${visible === 1 ? count.dataset.singular : count.dataset.label}`;
        empty.hidden = visible > 0;
      }
      search.addEventListener('input', filter);
      category.addEventListener('change', filter);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', () => init());
})();
